module.exports = __webpack_public_path__ + "static/depot_pickup-91d187b5926b455b7de0667e6aae8bfb.jpg";